// English strings for P5-C (CHECKOUT, ORDER, CUSTOMER, PROMOTION, RISK, PAYMENT manual, SETTINGS tax, ANALYTICS basic, NOTIFY templates) (D-013: English only). Owned by that worker; spread into `en` as
// `en.commerce`, so keys read `t("commerce.…")`.
export const commerceStrings = {
  money: "{amount}",
  unfinished: {
    title: "Unfinished checkouts",
    lead: "Shoppers who got a delivery price but didn't place the order.",
    infoTitle: "A shopper says they paid?",
    infoBody:
      "These carts never became orders. Before you contact the shopper, check Earnings → Online payments for a payment that is waiting to be matched.",
    periodLabel: "Period",
    period: { d7: "Last 7 days", d30: "Last 30 days", all: "All" },
    caption: "Unfinished checkouts",
    columns: {
      hash: "#",
      type: "Type",
      items: "Items",
      customer: "Customer",
      contact: "Contact",
      updated: "Last activity",
    },
    kind: { cart: "Cart", buy_now: "Buy now", link: "Checkout link" },
    items: { one: "{count} item", other: "{count} items" },
    known: "Known customer",
    guest: "Guest",
    canContact: "Can contact",
    noConsent: "No consent",
    openCustomer: "Open customer",
    emptyTitle: "No unfinished checkouts",
    emptyBody:
      "When a shopper gets a delivery price and leaves for 30 minutes, the checkout shows up here.",
    recoveryNote: "Reminder messages turn on with automations once SMS or email is activated.",
  },
  orders: {
    title: "Orders",
    lead: "Every order from your store, POS and manual sales, in one queue.",
    searchLabel: "Search orders",
    searchPlaceholder: "Order number, name or phone",
    tableCaption: "Orders",
    viewsLabel: "Order views",
    views: {
      all: "All",
      "to-confirm": "To confirm",
      "awaiting-verification": "Payment to check",
      "unfulfilled-48h": "Late (48 h)",
      "stuck-dispatch": "Stuck at dispatch",
      overpaid: "Overpaid",
      "paid-out-of-stock": "Paid, out of stock",
      "unconfirmed-cod": "Unconfirmed COD",
    },
    columns: {
      number: "Order",
      customer: "Customer",
      total: "Total",
      status: "Status",
      payment: "Payment",
      placed: "Placed",
      sla: "Due by",
      hash: "#",
      customerName: "Customer name",
      totalAmount: "Total amount",
      codAmount: "COD amount",
      method: "Payment method",
      orderPayment: "Order / payment status",
      created: "Created",
      actions: "Actions",
    },
    newOrder: "New order",
    create: {
      title: "Create order",
      customer: "Customer",
      phone: "Phone",
      phoneHint: "98XXXXXXXX",
      name: "Customer name",
      searchCustomer: "Search customer",
      noCustomer: "No saved customer with this phone. Type the name to add one.",
      city: "City / municipality",
      cityHint: "Type to search, e.g. Pokhara",
      ward: "Ward",
      products: "Products ({count})",
      addProducts: "Add products",
      // eslint-disable-next-line ady/tenant-sql-org-id -- UI text ("Update products"), not SQL
      updateProducts: "Update products",
      noProducts: "No products selected",
      product: "Product",
      variant: "Variant",
      qty: "Qty",
      price: "Price",
      lineTotal: "Line total",
      increase: "Add one {title}",
      decrease: "Remove one {title}",
      pricesNote:
        "Prices come from your catalogue. Delivery is worked out by the server from the address, like on your website.",
      address: "Address (tole, street)",
      landmark: "Landmark",
      summary: "Summary",
      emptySummary: "Add products to see the total.",
      subtotal: "Sub-total ({count} items)",
      delivery: "Delivery",
      deliveryAuto: "Worked out on create",
      total: "Total",
      source: "Order from",
      sources: {
        phone: "Phone",
        whatsapp: "WhatsApp",
        instagram: "Instagram",
        facebook: "Facebook",
        tiktok: "TikTok",
        walk_in: "Walk-in",
        other: "Other",
      },
      service: "Delivery",
      services: { standard: "Standard", express: "Express", pickup: "Store pick-up" },
      paymentMethod: "Payment method",
      methods: {
        cod: "COD",
        cash: "Cash",
        bank_transfer: "Bank transfer",
        merchant_qr: "QR",
        esewa: "eSewa",
        khalti: "Khalti",
        other: "Other",
      },
      paymentStatus: "Payment status",
      paymentStatuses: { unpaid: "Unpaid", paid: "Paid", partial: "Partial" },
      secCustomer: "Customer",
      secAddress: "Delivery address",
      secProducts: "Products",
      secProductsCount: "Products ({count})",
      find: "Find",
      returning: "Returning customer · {count} orders",
      cityPh: "City / municipality, e.g. Pokhara",
      wardPh: "Ward",
      district: "District",
      districtPh: "District",
      wardN: "Ward {ward}",
      tolePh: "Tole, street",
      landmarkPh: "Landmark (optional)",
      notePh: "Order note (optional)",
      paidNow: "paid now",
      payment: "Payment",
      each: "{price} each",
      remove: "Remove {title}",
      addHint: "Search your catalogue; stock and prices come with them.",
      fromAddress: "From the address",
      subtotalShort: "Sub-total",
      paidAmount: "Amount paid",
      note: "Order note",
      cancel: "Cancel",
      submit: "Create order",
      creating: "Creating…",
      needs: "Add a customer, an address and at least one product to create the order.",
      created: "Order #{number} created",
      pickTitle: "Select products",
      pickSearch: "Search products",
      pickImage: "Image",
      pickSku: "SKU",
      pickStock: "Stock",
      pickUnit: "Unit price",
      pickConfirm: "Add to order ({count})",
      pickedCount: "{count} selected",
      inStock: "{count} in stock",
      outOfStock: "Out of stock",
      untracked: "Not tracked",
      pickEmpty: "No products match.",
      pickRow: "Select {title}",
    },
    bulk: {
      selected: "{count} selected",
      label: "Add label",
      print: "Print order",
      pickList: "Pick list",
      packingSlips: "Packing slips",
      courier: "Submit to logistics",
      sms: "Send SMS",
      smsPending: "SMS turns on when an SMS provider is activated.",
      export: "Export order",
      clear: "Clear",
      preparing: "Preparing the document…",
      ready: "Document ready",
      open: "Open document",
      failed: "The document could not be made. Try again.",
      booked: "{accepted} of {requested} sent to the courier",
      delete: "Delete order",
      deleteTitle: "Delete {count} orders?",
      deleteNote:
        "Only Cancelled and Returned orders are deleted. To delete another order, change its status to Cancelled or Returned first.",
      deleteConfirm: "Delete",
      deleteConfirmN: "Delete {count}",
      willDelete: "Will be deleted",
      willKeep: "Kept",
      deleteDone: "{deleted} deleted, {skipped} kept",
      deleteNone: "None of these orders are Cancelled or Returned, so nothing was deleted.",
      deleteWorking: "Deleting…",
      smsTitle: "Compose bulk SMS",
      smsPh: "Write the message you want to send to all selected customers…",
      smsChars: "{count} chars",
      smsParts: "SMS parts: {parts} · {per}/part",
      smsVars:
        "Variables like $name only work in automatic (event) SMS; here they are sent as written.",
      smsRecipients: "Recipients",
      smsNeeded: "SMS needed",
      smsBalance: "Balance",
      smsBalanceNone: "Not active",
      smsReview: "Review and send",
      logTitle: "Submit to logistics",
      logProvider: "Logistics provider",
      logAuto: "Automatic (default courier)",
      logEligible:
        "{eligible} of {total} orders can go to a courier (Confirmed, Packing or Ready to ship, and not booked yet).",
      logPreview: "Preview matches",
      logBack: "Back",
      logSubmit: { one: "Submit {count} order", other: "Submit {count} orders" },
      logNoCouriers: "No courier is connected yet.",
      logConnect: "Connect a courier",
      logHigh: "High: {count}",
      logMedium: "Medium: {count}",
      logLow: "Low: {count}",
      logWithLocation: "{count} with location",
      logOrder: "Order",
      logAddress: "Address",
      logArea: "Delivery area",
      logMatch: "Match",
      logMatchNote:
        "Match shows how complete each address is: municipality and ward (high), district only (medium), missing (low).",
      logLoading: "Getting the orders…",
      matchLevel: { high: "High", medium: "Medium", low: "Low" },
    },
    labels: {
      title: "Select label",
      titleFor: "Select label (#{number})",
      titleMany: "Select label ({count} orders)",
      column: "Labels",
      edit: "Edit labels of #{number}",
      none: "No labels yet. Create one below.",
      create: "Create label",
      newHint: "Label name",
      add: "Add",
      save: "Save changes",
      saved: "Labels saved",
      // Owner, 2026-11-05: the built-in Delivered label also marks the order delivered.
      savedDelivered: {
        one: "Labels saved. {count} order marked delivered.",
        other: "Labels saved. {count} orders marked delivered.",
      },
      deliveredReason: "Delivered label (confirmed by phone)",
      deliverSkipped: "Not marked delivered (cancelled, returned or draft): #{numbers}",
      remove: "Remove label {name}",
      createTitle: "Create label",
      createLink: "Create label",
      nameLabel: "Label name",
      namePh: "e.g. CNR",
      color: "Select colour",
      colors: {
        orange: "Orange",
        amber: "Amber",
        mint: "Mint",
        green: "Green",
        sky: "Sky",
        blue: "Blue",
        gray: "Grey",
        red: "Red",
        pink: "Pink",
        purple: "Purple",
      },
      createBtn: "Create label",
      back: "Back",
      deleteLabel: "Delete label {name}",
      duplicate: "A label with this name already exists.",
    },
    moreActions: "More order actions",
    more: {
      pos: "Create order (POS interface)",
      exportExcel: "Export to Excel",
      exporting: "Preparing the file…",
      exported: "{count} orders exported",
      cod: "COD reconciliation",
      importExport: "Import and export",
      invoices: "Invoices and receipts",
      returns: "Returns and exchanges",
      dispatch: "Dispatch",
    },
    openOrder: "Open order #{number}",
    period: {
      label: "Period",
      all: "All time",
      today: "Today",
      yesterday: "Yesterday",
      d7: "Last 7 days",
      d30: "Last 30 days",
      month: "This month",
      lastMonth: "Last month",
      custom: "Custom dates",
    },
    range: {
      title: "Date range",
      all: "All dates",
      from: "From",
      to: "To",
      apply: "Apply",
      clear: "Clear dates",
      prev: "Previous month",
      next: "Next month",
      days: "{count} days",
      hint: "Pick the first day, then the last.",
    },
    filters: {
      title: "Filters",
      any: "Any",
      status: "Order status",
      payment: "Payment status",
      method: "Payment method",
      channel: "Sales channel",
      clear: "Clear filters",
      close: "Close",
      active: "{count} on",
      done: "Done",
    },
    logistics: {
      title: "Logistics status",
      clear: "All parcels",
      states: {
        booked: "Waiting pickup",
        picked_up: "At courier warehouse",
        in_transit: "In transit",
        out_for_delivery: "Out for delivery",
        failed_attempt: "Delivery failed",
        rto: "Returning",
        delivered: "Delivered",
        cancelled: "Delivery cancelled",
      },
    },
    export: {
      number: "Order",
      created: "Created",
      customer: "Customer",
      phone: "Phone",
      district: "District",
      total: "Total (Rs)",
      due: "Due (Rs)",
      method: "Payment method",
      payment: "Payment status",
      status: "Order status",
      logistics: "Logistics status",
      labels: "Labels",
    },
    searchHint: "Name, phone or order #",
    number: "#{number}",
    late: "Late",
    onTime: "On time",
    emptyTitle: "No orders here",
    emptyBody: "Orders from your store, POS and manual sales appear here as they come in.",
    noResultsTitle: "No orders match",
    noResultsBody: "Try another number, name or phone.",
    loadMore: "Load more",
    channel: {
      web: "Online store",
      pos: "POS",
      manual: "Manual",
      headless: "Headless",
      marketplace: "Marketplace",
      ai: "root",
    },
  },
  print: {
    title: "Print preview",
    print: "Print",
    download: "Download PDF",
    downloadHint: "In the print window, choose Save as PDF.",
    settings: "Print settings",
    close: "Close",
    page: "Page",
    format: "Print format",
    pages: { a6: "A6 (label)", a4: "A4" },
    formats: {
      label: "Shipping label",
      invoice: "Invoice",
      pick_list: "Pick list (warehouse)",
      packing_slip: "Packing slip (per order)",
    },
    loading: "Getting the orders…",
    failed: "Some orders could not be loaded. Try again.",
    none: "No orders to print.",
    count: { one: "{count} order", other: "{count} orders" },
    name: "Name",
    phone: "Phone",
    address: "Address",
    landmark: "Landmark",
    note: "Note",
    cod: "COD amount",
    prepaid: "Prepaid",
    items: "Items",
    item: "Item",
    product: "Product",
    qty: "Qty",
    rate: "Rate",
    amount: "Amount",
    subtotal: "Sub-total",
    discount: "Discount",
    delivery: "Delivery charge",
    total: "Total amount",
    paid: "Paid",
    due: "Due",
    billTo: "Bill to",
    shipTo: "Ship to",
    orderInfo: "Order info",
    payment: "Payment",
    status: "Status",
    itemsCount: "{skus} SKU · {units} units",
    invoiceTitle: "Invoice",
    pickTitle: "Pick list",
    packTitle: "Packing slips",
    generated: "Generated {time}",
    pickSummary: "Orders: {orders} · SKUs to pick: {skus} · Total units: {units}",
    pickFooter: "{orders} orders · {skus} SKUs · {units} units",
    ordersOf: "Orders: {list}",
    madeWith: "Printed with Adyvance",
    courier: {
      collect: "Collect COD",
      prepaid: "Prepaid · collect nothing",
      tracking: "Tracking no.",
      to: "Deliver to",
      from: "From",
      pickup: "Pickup point: {branch}",
      service: "Home delivery",
      orderLine: "Order #{number} · Qty {count} · {date}",
      more: "+{count} more",
      weight: "Weight {kg} kg",
      sign: "Received by (sign)",
    },
    pageOf: "Page {page} / {pages}",
  },
  status: {
    order: {
      draft: "Draft",
      pending: "New",
      confirmed: "Confirmed",
      processing: "Packing",
      ready: "Ready to ship",
      shipped: "With courier",
      delivered: "Delivered",
      completed: "Completed",
      cancelled: "Cancelled",
      returned: "Returned",
    },
    payment: {
      unpaid: "Unpaid",
      partial: "Partly paid",
      paid: "Paid",
      refunded: "Refunded",
      partially_refunded: "Partly refunded",
      awaiting_verification: "Payment to check",
      overpaid: "Overpaid",
    },
    method: {
      cod: "COD",
      manual_qr: "QR",
      fonepay_qr: "Fonepay QR",
      fonepay_web: "Fonepay",
      esewa: "eSewa",
      khalti: "Khalti",
      stripe: "Card (Stripe)",
      cash: "Cash",
      bank_transfer: "Bank transfer",
      wallet: "Wallet",
      cheque: "Cheque",
      other: "Other",
    },
  },
  detail: {
    back: "Back to orders",
    loadFailed: "Couldn't load this order",
    placedOn: "Placed {date}",
    items: "Items",
    qtyTimes: "{qty} × {price}",
    priceTimes: "{price} × {qty}",
    viewPhoto: "View photo",
    totals: "Summary",
    subtotal: "Subtotal",
    discount: "Discount",
    delivery: "Delivery",
    storePickup: "Store pickup (customer collects)",
    expressDelivery: "Express delivery",
    surcharge: "COD fee",
    tax: "VAT",
    taxIncluded: "VAT (included)",
    total: "Total",
    paid: "Paid",
    due: "Amount due",
    customer: "Customer",
    phone: "Phone",
    email: "Email",
    address: "Delivery address",
    wardLine: "Ward {ward}, {local}",
    noAddress: "No delivery address",
    payments: "Payments",
    noPayments: "No payments recorded yet.",
    manualBadge: "Manual",
    proofs: "Payment proofs",
    timeline: "Timeline",
    timelineEmpty: "Nothing has happened yet.",
    actions: "Actions",
    move: {
      confirmed: "Confirm order",
      processing: "Start packing",
      ready: "Mark ready",
      shipped: "Mark shipped",
      delivered: "Mark delivered",
      completed: "Complete",
      returned: "Mark returned",
      cancelled: "Cancel order",
      pending: "Reopen",
      draft: "Back to draft",
    },
    moved: "Order #{number} is now {status}.",
    // Owner, 2026-11-05: delivered without a courier update.
    deliverTitle: "Mark order #{number} as delivered?",
    deliverBody:
      "Use this when you confirmed the delivery yourself. Once it is paid, the customer gets one message with a link to review it.",
    deliverHowLabel: "How was it confirmed?",
    deliverHow: {
      phone: "Confirmed by phone",
      pickup: "Customer picked up",
      rider: "Own rider delivered",
      other: "Other",
    },
    deliverNote: "Note (optional)",
    deliverNotePh: "e.g. Called the customer at 4 pm",
    cancelTitle: "Cancel order #{number}?",
    cancelBody:
      "Stock goes back on the shelf and any coupon use is given back. The customer sees the order as cancelled.",
    cancelReason: "Reason",
    cancelReasonHelp: "Visible to your team in the order timeline.",
    keepOrder: "Keep order",
    reasonRequired: "Enter a reason.",
    markPaid: "Record a payment",
    markPaidTitle: "Record a payment for #{number}",
    markPaidBody:
      "Use this when money arrived outside the store (cash, bank transfer). It is marked as manual and logged with your name.",
    amount: "Amount",
    method: "Method",
    reason: "Reason",
    reference: "Reference",
    paymentRecorded: "Payment recorded.",
    holds: "Stock",
    holdState: {
      held: "Reserved",
      committed: "Taken from stock",
      released: "Released",
      restocked: "Returned to stock",
    },
    illegal: "That step isn't possible from here.",
    dispatchedLocked: "Items and address are locked after dispatch.",
    events: {
      order_created: "Order placed",
      order_status_changed: "Status changed to {status}",
      order_edited: "Items edited",
      order_updated: "Details updated",
      payment_proof_submitted: "Customer sent a payment proof",
      payment_verified: "Payment verified",
      payment_rejected: "Payment proof rejected",
      payment_recorded: "Payment recorded manually",
      shipment_booked: "Booked with {courier} · tracking {tracking}",
      shipment_pickup_requested: "Courier pickup requested",
      other: "Update",
    },
    byCustomer: "Customer",
    bySystem: "System",
    byStaff: "Staff",
    close: "Close order",
    loading: "Loading order",
    created: "Created:",
    modified: "Modified:",
    orderStatus: "Order status",
    paymentStatus: "Payment status",
    logistics: "Submit to logistics",
    sendItemNames: "Send product names to the courier",
    sendItemNamesHelp: "Off: the courier sees only the order number and how many items.",
    logisticsHint: "Your default courier takes it, or the one that delivers to this address.",
    bookCourier: "Submit",
    booked: "Order #{number} was sent to the courier.",
    parcel: "Delivery",
    tracking: "Tracking {number}",
    parcelUpdated: "Updated {time}",
    parcelAuto: "The status updates automatically from the courier.",
    cancelWithCourier: "To cancel, contact {courier}.",
    parcelRefused: "{courier} did not accept this parcel:",
    retryBooking: "Try again",
    retrySent: "Sent to the courier again.",
    paymentMethod: "Payment method:",
    coupons: "Coupons:",
    orderSummary: "Order summary",
    cartItems: "Cart items",
    noPhoto: "No photo",
    customerDetails: "Customer details",
    fields: {
      name: "Name:",
      email: "Email:",
      phone: "Phone number:",
      altPhone: "Alt phone number:",
      province: "Province:",
      district: "District:",
      address: "Address:",
      landmark: "Landmark:",
      note: "Order note:",
    },
    tabs: { payments: "Payments", activity: "Activity", stock: "Stock movements" },
    tabsLabel: "Order records",
    noHolds: "No stock movements yet.",
    print: "Print order",
    invoice: "Print invoice",
    preparing: "Preparing the document…",
    openDocument: "Open document",
    documentFailed: "Couldn't prepare the document.",
  },
  payments: {
    title: "Payments",
    lead: "Check QR payments, see every payment and choose how customers can pay.",
    tabs: { queue: "To check", records: "Payments", methods: "Methods", accounts: "QR accounts" },
    queueCaption: "Payments waiting for a check",
    queueEmptyTitle: "Nothing to check",
    queueEmptyBody:
      "When a customer sends a QR payment screenshot, it waits here until you confirm the money arrived.",
    waiting: { one: "Waiting {count} minute", other: "Waiting {count} minutes" },
    reference: "Ref {code}",
    noReference: "No reference",
    viewProof: "View screenshot",
    verify: "Money received",
    reject: "Not received",
    verifyTitle: "Confirm payment for #{number}?",
    verifyBody: "Only confirm after you see {amount} in your wallet or bank app.",
    rejectTitle: "Reject the proof for #{number}?",
    rejectBody:
      "The customer sees that the payment couldn't be confirmed and can send a new proof.",
    reasonLabel: "Note",
    verifyReasonPlaceholder: "e.g. Matched in the Fonepay app",
    rejectReasonPlaceholder: "e.g. No money received",
    verified: "Payment for #{number} confirmed.",
    rejected: "Proof for #{number} rejected.",
    recordsCaption: "Payment records",
    recordsEmptyTitle: "No payments yet",
    recordsEmptyBody: "Confirmed QR payments and payments you record appear here.",
    columns: {
      order: "Order",
      method: "Method",
      amount: "Amount",
      status: "Status",
      when: "When",
      customer: "Customer",
      proof: "Proof",
    },
    recordStatus: {
      pending: "Pending",
      succeeded: "Received",
      failed: "Failed",
      reversed: "Reversed",
    },
    methodsTitle: "Payment methods",
    methodState: {
      active: "Active",
      pending_activation: "Waiting for activation",
      error: "Needs attention",
    },
    methodReason: {
      gateway_phase_6:
        "Online gateways open after their sandbox checks. Until then customers can't choose them.",
      no_qr_account: "Add a QR account so customers know where to pay.",
      disabled: "Turned off for this store.",
    },
    methodDescription: {
      cod: "Customers pay the rider when the parcel arrives.",
      manual_qr: "Customers scan your QR, then send a screenshot that you check.",
      fonepay_qr: "Dynamic QR that confirms itself.",
      fonepay_web: "Fonepay's own payment page; confirms itself.",
      esewa: "eSewa wallet checkout.",
      khalti: "Khalti wallet checkout.",
      stripe: "Card checkout on Stripe.",
    },
    enable: "Accept {method}",
    methodSaved: "{method} updated.",
    accountsTitle: "QR accounts",
    accountsEmptyTitle: "No QR accounts",
    accountsEmptyBody: "Add the wallet or bank QR you want customers to pay into.",
    addAccount: "Add QR account",
    accountLabel: "Name shown to customers",
    accountKind: "Type",
    kind: { wallet: "Wallet", bank: "Bank" },
    accountName: "Account holder",
    instructions: "Instructions",
    accountAdded: "QR account added.",
    accountActive: "Shown at checkout",
    noQrImage: "No QR image yet",
    proofTitle: "Customer's screenshot",
    proofAlt: "Payment screenshot from the customer",
  },
  customers: {
    title: "Customers",
    lead: "People who ordered from you, with their order history.",
    leadMatched: "Everyone from your orders, identified by phone number.",
    searchHint: "Search…",
    exportCsv: "Export CSV",
    open: "Open {name}",
    columnsMatched: {
      hash: "#",
      name: "Customer name",
      phone: "Phone number",
      orders: "Total orders",
      // D-106: customers.ltv_paisa sums their orders' totals (paid or not), so not "Spent".
      spent: "Order value",
      last: "Last order",
      type: "Type",
      actions: "Actions",
    },
    searchLabel: "Search customers",
    searchPlaceholder: "Name, phone or email",
    caption: "Customers",
    columns: {
      name: "Name",
      phone: "Phone",
      orders: "Orders",
      spent: "Order value",
      last: "Last order",
      district: "District",
    },
    emptyTitle: "No customers yet",
    emptyBody: "Customers are added automatically with their first order.",
    noResultsTitle: "No customers match",
    noResultsBody: "Try another name, phone or email.",
    unnamed: "No name",
    back: "Back to customers",
    orders: "Orders",
    banned: "Blocked",
    breadcrumb: "Breadcrumb",
    contact: "Contact",
    newBadge: "New",
    sectionsLabel: "Customer records",
    privacy: "Privacy and consent",
    piiHidden: "Contact details are hidden for your role.",
    add: "Add customer",
    returning: "Returning",
    viewsLabel: "Customer views",
    views: { all: "All", new: "New", returning: "Returning", blocked: "Blocked" },
    clearFilter: "Show all customers",
    loadMore: "Load more",
    popup: {
      close: "Close",
      since: "Customer since {date}",
      orders: "Orders",
      spent: "Order value",
      average: "Average order",
      last: "Last order",
      phone: "Phone",
      email: "Email",
      district: "District",
      tags: "Tags",
      note: "Note",
      call: "Call",
      copyPhone: "Copy phone number",
      copied: "Copied",
      copyFailed: "Couldn't copy. Select the text and copy it instead.",
      recent: "Recent orders",
      noOrders: "No orders yet.",
      privacy: "Privacy, consent and data requests",
      createOrder: "Create order",
      edit: "Edit customer",
    },
    form: {
      addTitle: "Add customer",
      editTitle: "Edit customer",
      name: "Name",
      namePh: "Full name",
      phone: "Phone",
      email: "Email",
      emailPh: "name@example.com",
      contactLocked: "Phone and email come from the customer's orders and can't be changed here.",
      secContact: "Customer",
      preview: "New customer",
      previewHint: "Phone and email show here",
      addHint: "Customers are also added automatically with their first order.",
      tags: "Tags",
      tagsPh: "Type a tag and press Enter, e.g. wholesale",
      note: "Note for staff",
      notePh: "Only your team sees this",
      cancel: "Cancel",
      add: "Add customer",
      save: "Save changes",
      needed: "Enter a name and phone number.",
      added: "{name} added",
      saved: "{name} saved",
      phoneTaken: "A customer with this phone number already exists.",
      exists: "This customer already exists",
      existsOrders: { one: "{count} order", other: "{count} orders" },
      existsBadge: "Already a customer",
      viewExisting: "View",
      checking: "Checking this number…",
    },
    menu: {
      contact: "Contact",
      call: "Call",
      copy: "Copy phone",
      customer: "Customer",
      view: "View details",
      edit: "Edit details",
      order: "Create order",
      copyEmail: "Copy email",
      privacyGroup: "Privacy",
      privacy: "Privacy and consent",
    },
    export: {
      name: "Name",
      phone: "Phone",
      email: "Email",
      orders: "Orders",
      spent: "Order value (Rs)",
      last: "Last order",
      district: "District",
      tags: "Tags",
      blocked: "Blocked",
      yes: "Yes",
      none: "No customers to export.",
      done: { one: "{count} customer exported", other: "{count} customers exported" },
    },
  },
  promotions: {
    filters: {
      searchHint: "Search codes",
      searchLabel: "Search coupons",
      typeLabel: "Coupon type",
      typeAll: "Type: All",
      types: {
        percent: "Type: Percentage",
        fixed: "Type: Fixed amount",
        free_delivery: "Type: Free delivery",
        delivery_discount: "Type: Delivery discount",
      },
      statusLabel: "Coupon status",
      status: {
        all: "All",
        live: "Live",
        scheduled: "Scheduled",
        paused: "Paused",
        ended: "Ended",
      },
    },
    title: "Coupons",
    lead: "Discount codes for your store. Codes work in any letter case.",
    create: "New coupon",
    caption: "Coupons",
    emptyTitle: "No coupons yet",
    emptyBody: "Create a code such as DASHAIN10 for a festival discount.",
    columns: { code: "Code", offer: "Offer", uses: "Used", window: "Valid", state: "State" },
    offer: {
      percent: "{value}% off",
      fixed: "{value} off",
      free_delivery: "Free delivery",
      delivery_discount: "{value} off delivery",
    },
    usesOf: "{used} of {limit}",
    usesUnlimited: "{used} · no limit",
    always: "Always",
    until: "Until {date}",
    from: "From {date}",
    active: "Active",
    paused: "Paused",
    pause: "Pause",
    resume: "Resume",
    remove: "Delete",
    removeTitle: "Delete coupon {code}?",
    removeBody: "Orders that already used it keep their discount.",
    form: {
      title: "New coupon",
      code: "Code",
      codeHelp: "3–32 letters or numbers. Customers can type it in any case.",
      type: "Discount",
      percentValue: "Percent off",
      fixedValue: "Amount off",
      limitTotal: "Total uses",
      limitTotalHelp: "Leave empty for no limit. The last use can only be claimed once.",
      limitPerCustomer: "Uses per customer",
      minOrder: "Minimum order",
      save: "Create coupon",
    },
    types: {
      percent: "Percent",
      fixed: "Fixed amount",
      free_delivery: "Free delivery",
      delivery_discount: "Delivery discount",
    },
    created: "Coupon {code} created.",
    saved: "Coupon updated.",
    deleted: "Coupon deleted.",
    codeTaken: "That code is already in use.",
    invalid: "Check the highlighted fields.",
  },
  tax: {
    title: "Taxes",
    lead: "VAT for this store. The checkout and every order use these settings.",
    registered: "Charge VAT",
    registeredHelp: "Turn on only if your business is VAT-registered.",
    inclusive: "Prices include VAT",
    inclusiveHelp: "Rs 1,130 with VAT included means Rs 1,000 + Rs 130 VAT.",
    delivery: "Charge VAT on delivery",
    rate: "Standard rate",
    rateValue: "{rate}%",
    adviser: "Confirm the rate and rules with your tax adviser.",
    saved: "Tax settings saved.",
    conflict: "Someone else changed these settings. Reload to see the latest.",
    classes: "Tax classes",
    classLabels: { standard: "Standard", exempt: "VAT exempt", zero: "Zero-rated" },
  },
  today: {
    title: "Sales today",
    periods: { today: "Today", "7d": "7 days", "30d": "30 days" },
    periodLabel: "Period",
    orders: "Orders",
    sales: "Sales",
    average: "Average order",
    collected: "Collected",
    outstanding: "To collect",
    previous: "Before: {value}",
    queue: "Needs you",
    toConfirm: "To confirm",
    toCheck: "Payments to check",
    late: "Late orders",
    unconfirmedCod: "Unconfirmed COD",
    emptyTitle: "No orders in this period",
    emptyBody: "Sales numbers appear here as orders come in.",
    loadFailed: "Couldn't load sales numbers",
    queueItem: "{label}: {count}",
  },
  errors: {
    illegal_transition: "That step isn't possible from here.",
    edit_after_dispatch: "This order can no longer be edited.",
    already_decided: "This payment was already checked.",
    insufficient_stock: "Not enough stock for this change.",
    version: "This changed meanwhile. Reload and try again.",
  },
} as const;
